(function () {
  var root = document.querySelector('[data-ms-books-filters]');
  if (!root) return;

  var search = root.querySelector('[data-ms-filter-search]');
  var countEl = root.querySelector('[data-ms-filter-count]');
  var clearBtn = root.querySelector('[data-ms-filter-clear]');
  var emptyEl = root.querySelector('[data-ms-filter-empty]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ms-card]'));

  var state = { q: '', gender: '', age: '', topic: '' };

  function closeAll(except) {
    root.querySelectorAll('[data-ms-dd]').forEach(function (dd) {
      if (except && dd === except) return;
      var menu = dd.querySelector('[data-ms-dd-menu]');
      var btn = dd.querySelector('[data-ms-dd-toggle]');
      if (menu) menu.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
      dd.classList.remove('is-open');
    });
  }

  root.querySelectorAll('[data-ms-dd]').forEach(function (dd) {
    var toggle = dd.querySelector('[data-ms-dd-toggle]');
    var menu = dd.querySelector('[data-ms-dd-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = menu.hidden;
      closeAll();
      if (open) {
        menu.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        dd.classList.add('is-open');
      }
    });

    menu.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  document.addEventListener('click', function () {
    closeAll();
  });

  function filterAttr(btn) {
    if (btn.hasAttribute('data-ms-filter-gender')) return 'data-ms-filter-gender';
    if (btn.hasAttribute('data-ms-filter-age')) return 'data-ms-filter-age';
    return 'data-ms-filter-topic';
  }

  function setActive(buttons, value) {
    buttons.forEach(function (btn) {
      btn.classList.toggle('is-active', (btn.getAttribute(filterAttr(btn)) || '') === value);
    });
  }

  function updateDropdownLabel(attr, value, fallback) {
    var btn = root.querySelector('[' + attr + '="' + value + '"]');
    var dd = btn && btn.closest('[data-ms-dd]');
    var label = dd && dd.querySelector('[data-ms-dd-label]');
    if (!label) return;
    if (!value) {
      label.textContent = fallback;
      dd.classList.remove('has-value');
    } else {
      label.textContent = btn.textContent.trim();
      dd.classList.add('has-value');
    }
  }

  root.querySelectorAll('[data-ms-filter-gender]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.gender = btn.getAttribute('data-ms-filter-gender') || '';
      setActive(root.querySelectorAll('[data-ms-filter-gender]'), state.gender);
      updateDropdownLabel('data-ms-filter-gender', state.gender, 'Género');
      closeAll();
      apply();
    });
  });

  root.querySelectorAll('[data-ms-filter-age]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.age = btn.getAttribute('data-ms-filter-age') || '';
      setActive(root.querySelectorAll('[data-ms-filter-age]'), state.age);
      updateDropdownLabel('data-ms-filter-age', state.age, 'Edad');
      closeAll();
      apply();
    });
  });

  root.querySelectorAll('[data-ms-filter-topic]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.topic = btn.getAttribute('data-ms-filter-topic') || '';
      setActive(root.querySelectorAll('[data-ms-filter-topic]'), state.topic);
      updateDropdownLabel('data-ms-filter-topic', state.topic, 'Tema');
      closeAll();
      apply();
    });
  });

  if (search) {
    search.addEventListener('input', function () {
      state.q = (search.value || '').trim().toLowerCase();
      apply({ debounce: 400 });
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      state = { q: '', gender: '', age: '', topic: '' };
      if (search) search.value = '';
      setActive(root.querySelectorAll('[data-ms-filter-gender]'), '');
      setActive(root.querySelectorAll('[data-ms-filter-age]'), '');
      setActive(root.querySelectorAll('[data-ms-filter-topic]'), '');
      updateDropdownLabel('data-ms-filter-gender', '', 'Género');
      updateDropdownLabel('data-ms-filter-age', '', 'Edad');
      updateDropdownLabel('data-ms-filter-topic', '', 'Tema');
      apply();
    });
  }

  function matches(card) {
    var title = (card.getAttribute('data-title') || '').toLowerCase();
    var gender = (card.getAttribute('data-gender') || 'unisex').toLowerCase();
    var ages = (card.getAttribute('data-ages') || '').toLowerCase().split(',').filter(Boolean);
    var topics = (card.getAttribute('data-topics') || '').toLowerCase().split(',').filter(Boolean);

    if (state.q && title.indexOf(state.q) === -1) return false;

    if (state.gender) {
      if (state.gender === 'unisex') {
        if (gender !== 'unisex') return false;
      } else if (gender !== state.gender && gender !== 'unisex') {
        return false;
      }
    }

    if (state.age && ages.indexOf(state.age) === -1) return false;
    if (state.topic && topics.indexOf(state.topic) === -1) return false;
    return true;
  }

  var trackTimer = null;
  var hasAppliedOnce = false;

  function apply(opts) {
    opts = opts || {};
    var visible = 0;
    cards.forEach(function (card) {
      var ok = matches(card);
      card.hidden = !ok;
      if (ok) visible += 1;
    });

    if (countEl) {
      countEl.textContent = visible + (visible === 1 ? ' libro' : ' libros');
    }
    if (emptyEl) emptyEl.hidden = visible > 0;
    if (clearBtn) {
      clearBtn.hidden = !(state.q || state.gender || state.age || state.topic);
    }

    if (!opts.silent && hasAppliedOnce) {
      if (trackTimer) clearTimeout(trackTimer);
      trackTimer = setTimeout(function () {
        try {
          if (typeof window.msTrack === 'function') {
            window.msTrack('collection_filtered', {
              query: state.q || null,
              gender: state.gender || null,
              age: state.age || null,
              topic: state.topic || null,
              results_count: visible
            });
          }
        } catch (e) {}
      }, opts.debounce || 0);
    }
    hasAppliedOnce = true;
  }

  apply({ silent: true });
})();
